export const FLAG_GETTING_CARGO_DELIVERY_FREQUENT_VEHICLES =
  'FLAG_GETTING_CARGO_DELIVERY_FREQUENT_VEHICLES';
export const GET_CARGO_DELIVERY_FREQUENT_VEHICLES =
  'GET_CARGO_DELIVERY_FREQUENT_VEHICLES';
export const CLEAR_CARGO_DELIVERY_FREQUENT_VEHICLES =
  'CLEAR_CARGO_DELIVERY_FREQUENT_VEHICLES';
